import React, { useState } from 'react'
import useMonthlyReportStyles from './styles'
import ReortTable from '../ReortTable/ReortTable'
import { Box, Grid } from '@mui/material'
import MonthlyInverterGraph from '../MonthlyInverterGraph/MonthlyInverterGraph'
import LogoP1 from '../../../../assets/images/de-logo.svg'
import moment from 'moment'
import CircularProgress from '@mui/material/CircularProgress'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import '../../businessview-style.scss'
const MonthlyReport = ({ monthlyReportList, state, fromDate, toDate }) => {
  const classes = useMonthlyReportStyles()

  const containerStyle = {
    position: 'relative',
    backgroundColor: 'white',
    padding: '50px',
  }

  const containerNewStyle = {
    position: 'relative',
    backgroundColor: 'white',
    padding: '40mm 20mm 20mm 20mm', // Standard A4 margins
    width: '210mm',
    minHeight: '297mm',
    margin: '20px auto',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    boxSizing: 'border-box',
    overflow: 'hidden',
  }
  const triangleStyle = {
    content: '',
    position: 'absolute',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    borderTop: '150mm solid #12487e',
    borderRight: '180mm solid transparent',
    zIndex: 0,
  }
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '11px',
    tableLayout: 'fixed',
  }
  const thStyle = {
    backgroundColor: '#f5f5f5',
    padding: '10px 8px',
    textAlign: 'left',
    borderBottom: '2px solid #12487e',
    fontWeight: 'bold',
    color: '#333',
  }
  const tdStyle = {
    borderBottom: '1px solid #eeeeee',
    padding: '10px 8px',
    textAlign: 'left',
    fontSize: '10px',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    color: '#444',
  }

  const [mapinverterData, setMapinverterData] = React.useState([])
  const [firstDates, setFirstDates] = useState([])
  const [Loading, setLoading] = useState(false)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [isDownloading, setIsDownloading] = useState(false)
  const dataArray = Object.entries(monthlyReportList?.data).map(
    ([month, values]) => ({
      month,
      ...values,
    })
  )
  const FiltereddeemedData = (data) => {
    return data.length > 0 ? (
      data?.map((Data, idx) => (
        <tr key={idx}>
          <td style={{ ...tdStyle, width: '80px' }}>{moment(Data?.logDate).format('DD-MM-YYYY')}</td>
          <td style={{ ...tdStyle, width: '120px' }}>{Data?.faultType}</td>
          <td style={{ ...tdStyle, width: '70px' }}>{Data?.energyLoss}</td>
          <td style={{ ...tdStyle }}>{Data?.description}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td style={tdStyle} colSpan={4} align="center">No loss logs available for this period.</td>
      </tr>
    )
  }

  const handlePrint = () => {
    setIsDownloading(true)
    let pdf = new jsPDF('p', 'mm', 'a4')

    // Collect all elements to print
    const printElements = []
    dataArray.forEach((Data, index) => {
      const summaryElement = document.getElementById(`summary-page-${index}`)
      if (summaryElement) printElements.push(summaryElement)

      const lossElement = document.getElementById(`loss-page-${index}`)
      if (lossElement) printElements.push(lossElement)
    })

    const capturePage = async (idx) => {
      if (idx >= printElements.length) return

      const element = printElements[idx]
      const canvas = await html2canvas(element, { scale: 2, useCORS: true })
      const imgData = canvas.toDataURL('image/png')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()

      pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight)

      if (idx < printElements.length - 1) {
        pdf.addPage()
        await capturePage(idx + 1)
      }
    }

    capturePage(0).then(() => {
      pdf.save(`monthly-report-${moment().format('YYYY-MM-DD')}.pdf`)
      setIsDownloading(false)
    })
  }

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <button
          style={{
            backgroundColor: '#12487e',
            outline: 'none',
            border: 'none',
            borderRadius: '4px',
            padding: '10px 20px',
            fontSize: '14px',
            fontWeight: '600',
            color: 'white',
            marginBottom: '20px',
            cursor: 'pointer',
            transition: 'background 0.3s',
          }}
          onClick={handlePrint}
        >
          {isDownloading ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px' }}>Generating PDF...</span>
              <CircularProgress size={16} style={{ color: 'white' }} />
            </div>
          ) : (
            'Download PDF Report'
          )}
        </button>
      </div>
      <div id="divToPrint">
        {Loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: `${screenHeight - 200}px`,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div
            style={{
              width: '100%',
              overflowX: 'auto',
              backgroundColor: '#f5f5f5',
              padding: '20px 0',
            }}
          >
            <div>
              {dataArray?.map((Data, index) => (
                <React.Fragment key={index}>
                  {/* Page 1: Summary and Graph */}
                  <div
                    id={`summary-page-${index}`}
                    style={containerNewStyle}
                  >
                    <div style={triangleStyle}></div>
                    <div
                      style={{
                        position: 'absolute',
                        top: 40,
                        right: 40,
                        textAlign: 'right',
                        zIndex: 1,
                      }}
                    >
                      <img
                        style={{ height: 60, marginBottom: 10 }}
                        src={LogoP1}
                        alt="DE logo"
                      />
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#12487e' }}>
                        Distributed Energy
                      </div>
                    </div>

                    <div style={{ position: 'relative', zIndex: 1, marginTop: '20mm' }}>
                      <h1 style={{ fontSize: '24px', color: '#333', marginBottom: '5px' }}>
                        Monthly Generation Report
                      </h1>
                      <h2 style={{ fontSize: '18px', color: '#666', fontWeight: 'normal', marginBottom: '30px' }}>
                        {moment(Data?.date).format('MMMM YYYY')}
                      </h2>

                      <div style={{ marginBottom: '40px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '15px', color: '#12487e', borderLeft: '4px solid #12487e', paddingLeft: '10px' }}>
                          Generation Analysis
                        </div>
                        {mapinverterData && (
                          <MonthlyInverterGraph
                            mapinverterData={Data?.eToday}
                            mapYieldData={Data?.yieldData}
                            Fromdate={firstDates[index]}
                            key={index}
                          />
                        )}
                      </div>

                      <div style={{ marginTop: '40px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '15px', color: '#12487e', borderLeft: '4px solid #12487e', paddingLeft: '10px' }}>
                          Performance Summary
                        </div>
                        <ReortTable monthlyReportList={Data} state={state} />
                      </div>
                    </div>
                  </div>

                  {/* Page 2: Loss Summary (always starts on new page) */}
                  <div
                    id={`loss-page-${index}`}
                    style={containerNewStyle}
                  >
                    <div style={{ ...triangleStyle, borderTop: '50mm solid #12487e', borderRight: '60mm solid transparent' }}></div>
                    <div
                      style={{
                        position: 'absolute',
                        top: 40,
                        right: 40,
                        textAlign: 'right',
                        zIndex: 1,
                      }}
                    >
                      <img
                        style={{ height: 40, marginBottom: 5 }}
                        src={LogoP1}
                        alt="DE logo"
                      />
                    </div>

                    <div style={{ position: 'relative', zIndex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '15px', color: '#12487e', borderLeft: '4px solid #12487e', paddingLeft: '10px', marginTop: '10mm' }}>
                        Loss Details Summary
                      </div>
                      <p style={{ fontSize: '11px', color: '#666', marginBottom: '20px' }}>
                        Details of all generation losses documented for the period {moment(Data?.date).format('MMMM YYYY')}.
                      </p>
                      <table style={tableStyle}>
                        <thead>
                          <tr>
                            <th style={{ ...thStyle, width: '85px' }}>Date</th>
                            <th style={{ ...thStyle, width: '130px' }}>Fault Type</th>
                            <th style={{ ...thStyle, width: '80px' }}>Loss (kWh)</th>
                            <th style={thStyle}>Description</th>
                          </tr>
                        </thead>
                        <tbody>{FiltereddeemedData(Data?.log)}</tbody>
                      </table>

                      {Data?.log?.length > 15 && (
                        <div style={{ marginTop: '20px', fontSize: '10px', color: '#999', fontStyle: 'italic' }}>
                          * Continued on next page if applicable.
                        </div>
                      )}
                    </div>

                    <div style={{ position: 'absolute', bottom: 40, left: 40, right: 40, borderTop: '1px solid #eee', paddingTop: '10px', display: 'flex', justifyContent: 'space-between', fontSize: '9px', color: '#999' }}>
                      <div>© {new Date().getFullYear()} Distributed Energy</div>
                      <div>Monthly Generation Report - {moment(Data?.date).format('MMMM YYYY')}</div>
                      <div>Page 2 of 2</div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
MonthlyReport.propTypes = {}

export default MonthlyReport
